import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, redMui } from "@ryde/theme";

export const HeaderSupplierPriceIndicatorStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "header-supplier-price-indicator",
  },
)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  margin-inline-start: 11px;

  svg {
    width: 20px;
    height: 20px;
    color: ${greyMui._700};
  }

  &.isRed svg {
    color: ${redMui._700};
  }
`;
